export const showEventNotifyModal = (store, show) => {
    store.setState({
        eventNotifyShown: show
    })
}
